const SubscriptionPaymentStatusEnum = {
    Success: 1,
    Pending: 2,
    Failed: 3,
    Cancelled: 4,
}
module.exports = SubscriptionPaymentStatusEnum;